var map = {
	"./app-icon.svg": 703,
	"./effect-advanced-idea-mechanics.svg": 704,
	"./effect-annoyances-assemble.svg": 705,
	"./effect-armor-break.svg": 706,
	"./effect-armor.svg": 707,
	"./effect-atonement.svg": 708,
	"./effect-attack.svg": 709,
	"./effect-avengers-tryout.svg": 710,
	"./effect-bad-for-business.svg": 711,
	"./effect-bane-of-hells-kitchen.svg": 712,
	"./effect-believer.svg": 713,
	"./effect-biochemistry.svg": 714,
	"./effect-birthright.svg": 715,
	"./effect-bleed.svg": 716,
	"./effect-block.svg": 717,
	"./effect-broken-minds.svg": 718,
	"./effect-chaotic-energy.svg": 719,
	"./effect-chronal-anchor.svg": 720,
	"./effect-civil-war-stories.svg": 721,
	"./effect-combo.svg": 722,
	"./effect-common-history.svg": 723,
	"./effect-competition.svg": 724,
	"./effect-contest-teammates.svg": 725,
	"./effect-contingency-plan.svg": 726,
	"./effect-cosmic-overload.svg": 727,
	"./effect-cosmic-supremacy.svg": 728,
	"./effect-critical-damage.svg": 729,
	"./effect-critical-rate.svg": 730,
	"./effect-crossover.svg": 731,
	"./effect-crowd-pleasers.svg": 732,
	"./effect-cybernetics-assault.svg": 733,
	"./effect-cybernetics-tactics.svg": 734,
	"./effect-deadly-presence.svg": 735,
	"./effect-deadly-string.svg": 736,
	"./effect-deadpools-guide.svg": 737,
	"./effect-deathwish.svg": 738,
	"./effect-degeneration.svg": 739,
	"./effect-demons.svg": 740,
	"./effect-directdamage.svg": 741,
	"./effect-drug-i.svg": 742,
	"./effect-drug-l.svg": 743,
	"./effect-drug-m.svg": 744,
	"./effect-elders-game.svg": 745,
	"./effect-electric-supercharge.svg": 746,
	"./effect-elemental-hide.svg": 747,
	"./effect-enhanced-with-carbonadium.svg": 748,
	"./effect-evade.svg": 749,
	"./effect-exhaust.svg": 750,
	"./effect-fantastic-four.svg": 751,
	"./effect-fatigue.svg": 752,
	"./effect-fire-and-forget.svg": 753,
	"./effect-fourth-wall-crawler.svg": 754,
	"./effect-friend-from-work.svg": 755,
	"./effect-gamma-ray-ray.svg": 756,
	"./effect-gateway.svg": 757,
	"./effect-genetic-recode-barrier.svg": 758,
	"./effect-genetic-recode-bloodletting.svg": 759,
	"./effect-genetic-recode-evolution.svg": 760,
	"./effect-genetic-recode-probability.svg": 761,
	"./effect-genetic-recode-regenesis.svg": 762,
	"./effect-genetic-recode-survival.svg": 763,
	"./effect-giant-challengers.svg": 764,
	"./effect-going-viral.svg": 765,
	"./effect-goodfella.svg": 766,
	"./effect-habitat.svg": 767,
	"./effect-heal-block.svg": 768,
	"./effect-heal.svg": 769,
	"./effect-health-steal.svg": 770,
	"./effect-health.svg": 771,
	"./effect-heightened-senses.svg": 772,
	"./effect-hell-lords.svg": 773,
	"./effect-heroes-for-hire.svg": 774,
	"./effect-huntress-of-the-contest.svg": 775,
	"./effect-idol.svg": 776,
	"./effect-immunity-bleed.svg": 777,
	"./effect-immunity-poison.svg": 778,
	"./effect-incinerate.svg": 779,
	"./effect-inseparable.svg": 780,
	"./effect-invasive-force.svg": 781,
	"./effect-just-hair-and-things.svg": 782,
	"./effect-like-old-days.svg": 783,
	"./effect-living-steel-curtain.svg": 784,
	"./effect-love-triangles.svg": 785,
	"./effect-lullaby.svg": 786,
	"./effect-masterminds.svg": 787,
	"./effect-masters-of-the-sword.svg": 788,
	"./effect-mental-immunity.svg": 789,
	"./effect-mercs-for-money.svg": 790,
	"./effect-metal-mayhem.svg": 791,
	"./effect-metallic.svg": 792,
	"./effect-miss.svg": 793,
	"./effect-mostly-average-joes.svg": 794,
	"./effect-mutant-agenda.svg": 795,
	"./effect-mutant-pursuit.svg": 796,
	"./effect-my-brotherhood.svg": 797,
	"./effect-my-contest-now.svg": 798,
	"./effect-mystic-arts.svg": 799,
	"./effect-mystic-observation.svg": 800,
	"./effect-mystic-tyrants.svg": 801,
	"./effect-new-mutants.svg": 802,
	"./effect-night-hawks.svg": 803,
	"./effect-nullify.svg": 804,
	"./effect-overcoming-fear.svg": 805,
	"./effect-particle-physics.svg": 806,
	"./effect-partners-shield.svg": 807,
	"./effect-perfect-block.svg": 808,
	"./effect-phalanx-feud.svg": 809,
	"./effect-poison.svg": 810,
	"./effect-poor-unfortunate-soul.svg": 811,
	"./effect-power-lock.svg": 812,
	"./effect-power.svg": 813,
	"./effect-prowess.svg": 814,
	"./effect-redemption.svg": 815,
	"./effect-regeneration.svg": 816,
	"./effect-remember-me.svg": 817,
	"./effect-resist-energy.svg": 818,
	"./effect-resist-physical.svg": 819,
	"./effect-runs-family.svg": 820,
	"./effect-science-research.svg": 821,
	"./effect-secret-of-the-hand.svg": 822,
	"./effect-seeing-red.svg": 823,
	"./effect-seething-hatred.svg": 824,
	"./effect-shared-genetic-memory.svg": 825,
	"./effect-shield.svg": 826,
	"./effect-shock.svg": 827,
	"./effect-sk-robotics.svg": 828,
	"./effect-skill-training.svg": 829,
	"./effect-sorcery-reversal.svg": 830,
	"./effect-soul-seeker.svg": 831,
	"./effect-spidermen-in-black.svg": 832,
	"./effect-spirit-of-justice.svg": 833,
	"./effect-student-loans.svg": 834,
	"./effect-stun-special.svg": 835,
	"./effect-stun.svg": 836,
	"./effect-swinester-six-most-wanted.svg": 837,
	"./effect-tactical-training.svg": 838,
	"./effect-tech-advancement.svg": 839,
	"./effect-thunderbolts.svg": 840,
	"./effect-tide-to-go.svg": 841,
	"./effect-till-death.svg": 842,
	"./effect-time.svg": 843,
	"./effect-two-days-thirty-years.svg": 844,
	"./effect-unending-ambition.svg": 845,
	"./effect-unstoppable.svg": 846,
	"./effect-untouchables.svg": 847,
	"./effect-wakandan-insight.svg": 848,
	"./effect-warrior-queens.svg": 849,
	"./effect-weakness.svg": 850,
	"./effect-weapon-x.svg": 851,
	"./effect-worthy-opponent.svg": 852,
	"./effect-xassassins.svg": 853,
	"./role-alliance-quest.svg": 854,
	"./role-alliance-war.svg": 855,
	"./role-arena.svg": 856,
	"./role-quest.svg": 857,
	"./special-1.svg": 858,
	"./special-2.svg": 859,
	"./special-3.svg": 860,
	"./synergy.svg": 861,
	"./type-cosmic.svg": 862,
	"./type-mutant.svg": 863,
	"./type-mystic.svg": 864,
	"./type-science.svg": 865,
	"./type-skill.svg": 866,
	"./type-tech.svg": 867,
	"./type-universal.svg": 868
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 702;



//////////////////
// WEBPACK FOOTER
// ./src/icons \.svg$
// module id = 702
// module chunks = 0